import Topless39Page, { pageQuery } from "src/pages/topless39";
import handleServerSideProps from "src/lib/handle-server-side-props";

export async function getServerSideProps({ params, ...context }) {
  const { data, result } = await handleServerSideProps({
    context,
    pageQuery,
    variables: params ? { year: params.year, week: params.week } : {},
  });

  if (!data.topChart) return { notFound: true };
  return result;
}

export default Topless39Page;
